<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

defineProps({
  loadingImage: Boolean
})

const showOptions = ref<boolean>(false)
const inputFileRef = ref<HTMLElement | null>(null)
const optionsRef = ref<HTMLElement | null>(null)

const isAndroid = () => {
  return /Android/i.test(navigator.userAgent)
}

const emit = defineEmits(['onChange'])

const onChange = (e: Event) => {
  emit('onChange', e)
}

const handleOption = (useCamera = false) => {
  if (useCamera) {
    inputFileRef.value!.setAttribute('capture', 'enviroment')
  } else {
    inputFileRef.value!.removeAttribute('capture')
  }

  showOptions.value = false
  inputFileRef.value?.click()
}

const show = () => {
  if (isAndroid()) {
    showOptions.value = true
  } else {
    inputFileRef.value?.click()
  }
}

const handleClickOutside = (event) => {
  if (optionsRef.value && !optionsRef.value.contains(event.composedPath()[0])) {
    showOptions.value = false
  }
}

onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('mousedown', handleClickOutside)
})
</script>

<template>
  <div
    :class="`rounded cursor-pointer relative w-10 h-10 ${loadingImage ? 'bg-sweet-brown' : 'bg-english-vermillion'} hover:bg-sweet-brown`"
  >
    <div class="h-full flex w-full justify-center flex-center absolute z-0">
      <img
        v-if="!loadingImage"
        alt="Camera icon"
        src="@/assets/icons/camera.svg"
        width="24"
        height="24"
      />
      <img
        v-else
        class="animate-spin"
        alt="Loading icon"
        src="@/assets/icons/loading.svg"
        width="24"
        height="24"
      />
    </div>

    <label class="absolute h-full w-full inset-0" @click="show"></label>
    <input
      ref="inputFileRef"
      type="file"
      hidden
      accept="image/*"
      @change="onChange"
      :disabled="loadingImage"
    />

    <div
      ref="optionsRef"
      v-if="showOptions"
      class="absolute top-1/2 right-0 w-28 rounded-xl overflow-hidden"
    >
      <ul class="text-white">
        <li
          class="p-2 backdrop-blur-sm bg-black/50 hover:bg-black/30 border-b-1"
          @click="handleOption()"
        >
          Choose File
        </li>
        <li class="p-2 backdrop-blur-sm bg-black/50 hover:bg-black/30" @click="handleOption(true)">
          Take Photo
        </li>
      </ul>
    </div>
  </div>
</template>
